import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { noop } from 'lodash-es';
import { TradeContext } from 'views/Conversation/Sider/StateContext';
import { TradeListContext } from 'views/Conversation/Sider/TradeContext';
import useTrade from 'views/Conversation/Sider/useTrade';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import DetailHeader from './components/DetailHeader';
import DetailList from './components/DetailList';
import ReplyEditor from './components/ReplyEditor';
import { reviewTrade } from './hooks/useNewReview';
import { useReviewContext } from './Context';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

function Detail(props: HTMLAttributes<HTMLDivElement>) {
  const trade = useAtomValue(reviewTrade);

  const { conversation } = useReviewContext();

  const useTradeResult = useTrade(conversation.storeId);

  const editable = useGetPermission()('访问评价聚合页');

  return (
    <Container {...props}>
      <DetailHeader />

      <TradeListContext.Provider
        value={{
          ...useTradeResult,
          conversation,
        }}
      >
        <TradeContext.Provider
          value={{
            state: trade!,
            setState: noop,
          }}
        >
          <DetailList />
        </TradeContext.Provider>
      </TradeListContext.Provider>
      {editable && <ReplyEditor />}
    </Container>
  );
}

export default Detail;
